export default {
	home() {
		import('./home');
	},
	post_type_archive_blog() {
		import('./post_type_archive_blog');
	},
	tax_blog_categories() {
		import('./post_type_archive_blog');
	},
	page_template_template_aanbiedingen() {
		import('./page_template_template_aanbiedingen');
	},
	page_template_template_review() {
		import('./page_template_template_review');
	},
	page_template_template_wishlist() {
		import('./page_template_template_wishlist');
	},
	ie() {
		import('./ie');
	},
	search() {
		import('./search');
	},
	tax_product_cat() {
		import('./tax_product_cat');
	},
	product_template_default() {
		import('./product_template_default');
	},
	woocommerce_page() {
		import('./woocommerce_page');
	},
	woocommerce_cart() {
		import('./woocommerce_cart');
	}
}
